
import Vue from 'vue';
import { CvHeader, CvHeaderName, CvIconButton } from '@carbon/vue';
import Close20 from '@carbon/icons-vue/es/close/20';

export default Vue.extend({
  components: {
    CvHeader,
    CvHeaderName,
    CvIconButton,
    Close20,
  },
});
